(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .controller('FreightPaymentAssignToShipmentController',FreightPaymentAssignToShipmentController);

    FreightPaymentAssignToShipmentController.$inject = ['entity','FreightPayment','FreightPaymentCustomService','ToastrService','$uibModalInstance','$scope','DateUtils'];

    function FreightPaymentAssignToShipmentController(entity, FreightPayment, FreightPaymentCustomService, ToastrService, $uibModalInstance, $scope, DateUtils) {
        var vm = this;

        vm.freightPayment = entity;
        vm.shipments = [];

        vm.clear = clear;
        vm.save = save;
        vm.refresh = refresh;
        vm.status = "Getting shipment list";

        fetchShipments();

        function fetchShipments() {
            vm.shipments = [];
            FreightPaymentCustomService.returnAvailableShipments().then(function(data) {
                vm.shipments = data.data;
                vm.status = "Shipment list is ready";
                ToastrService.success("Successfully fetched available Shipments");
            }, function(error) {
                ToastrService.error("Failed to fetch available Shipments");
                vm.status = "Failed to fetch available Shipments";
            });
        }

        function refresh() {
            vm.status = "Getting shipment list";
            fetchShipments();
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            FreightPayment.update(vm.freightPayment, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            $scope.$emit('ccsTrApp:freightPaymentUpdate', result);
            ToastrService.success("Successfully saved Freight Payment", "Success!");
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            ToastrService.error("Something went wrong", "Error");
            resolveDates();
            vm.isSaving = false;
        }

        function resolveDates() {
            if(vm.freightPayment.paymentDate !== null) {
                vm.freightPayment.paymentDate = DateUtils.convertLocalDateFromServer(vm.freightPayment.paymentDate);
            }
        }
    }
})();
